import { SegmentedControl, useIsWideViewport } from '@hue/design-system';
import type { ReactNode } from 'react';
import { useCollectionView } from './use-collection-view.js';

export function CollectionViewPicker() {
  const view = useCollectionView();
  return (
    <SegmentedControl
      compact
      label="Exibição dos registros"
      value={view}
      onChange={(value) => {
        localStorage.setItem('hue.collection-view', value);
        document.documentElement.dataset.collectionView = value;
        window.dispatchEvent(new Event('hue:collection-view'));
      }}
      options={[
        { value: 'list', label: 'Listagem' },
        { value: 'cards', label: 'Cards' },
      ]}
    />
  );
}

export function CollectionTable({ children }: { children: ReactNode }) {
  const view = useCollectionView();
  const wide = useIsWideViewport();
  return wide && view === 'list' ? children : null;
}
export function CollectionCards({ children }: { children: ReactNode }) {
  const view = useCollectionView();
  const wide = useIsWideViewport();
  return !wide || view === 'cards' ? children : null;
}
